export default __webpack_public_path__ + "static/media/videos.65b131f0.png";